import { Merge } from 'type-fest'

import { DipsSchemas } from '~/clients/dips-client'

export type DipsLocalization = DipsSchemas['LocationDto']
export type UnifiedDipsLocalization = Merge<{ entity_type: 'dips_localization' }, DipsLocalization>

export function transformDipsLocalizations(localizations: DipsLocalization[]): UnifiedDipsLocalization[] {
    return localizations.map(localization => ({
        ...localization,
        entity_type: 'dips_localization',
    }))
}
